import { Colours } from '../../../../design-system/colours';
import { DashboardColours } from '../../../../public/dashboard/shared/model/dashboard-colours';

/**
 * Temporary until we show sinks in the correct subsector.
 * @param sector
 */
export const colourForSinkNode = (): DashboardColours => {
  return {
    darkHover: Colours.grey600,
    dark: Colours.grey700,
    main: Colours.grey400,
    light: Colours.grey300,
    headingColour: Colours.grey200,
  };
};

export const colourForEmissionNodeV42 = (colour: string): DashboardColours => {
  switch (colour) {
    case 'green':
      return {
        darkHover: Colours.transport800,
        dark: Colours.transport900,
        main: Colours.transport600,
        light: Colours.transport500,
        headingColour: Colours.transport400,
      };
    case 'blue':
      return {
        darkHover: Colours.industry800,
        dark: Colours.industry900,
        main: Colours.industry600,
        light: Colours.industry500,
        headingColour: Colours.industry400,
      };
    case 'orange':
      return {
        darkHover: Colours.agriculture800,
        dark: Colours.agriculture900,
        main: Colours.agriculture600,
        light: Colours.agriculture500,
        headingColour: Colours.agriculture400,
      };
    case 'yellow':
      return {
        darkHover: Colours.energy800,
        dark: Colours.energy900,
        main: Colours.energy600,
        light: Colours.energy500,
        headingColour: Colours.energy400,
      };
    case 'pink':
      return {
        darkHover: Colours.other800,
        dark: Colours.other900,
        main: Colours.other600,
        light: Colours.other500,
        headingColour: Colours.other400,
      };
    case 'teal':
      return {
        darkHover: Colours.waste800,
        dark: Colours.waste900,
        main: Colours.waste600,
        light: Colours.waste500,
        headingColour: Colours.waste400,
      };
    case 'purple':
      return {
        darkHover: Colours.purple800,
        dark: Colours.purple900,
        main: Colours.purple600,
        light: Colours.purple500,
        headingColour: Colours.purple400,
      };
    default:
      return {
        darkHover: Colours.grey800,
        dark: Colours.grey900,
        main: Colours.grey600,
        light: Colours.grey500,
        headingColour: Colours.grey400,
      };
  }
};
